import colors from '../../../../../../styles/colors';

export enum Actor {
  CANDIDATE = 'CANDIDATE',
  RECRUITER = 'RECRUITER',
  CANDIDATE_OR_RECRUITER = 'CANDIDATE_OR_RECRUITER',
  SYSTEM = 'SYSTEM',
  NONE = 'NONE',
}

export const actorColorScheme = {
  [Actor.RECRUITER]: { color: colors.blue[500], colorScheme: 'blue' },
  [Actor.CANDIDATE]: { color: colors.orange[500], colorScheme: 'orange' },
  [Actor.CANDIDATE_OR_RECRUITER]: { color: colors.orange[500], colorScheme: 'orange' },
  [Actor.SYSTEM]: { color: colors.blue[500], colorScheme: 'blue' },
  [Actor.NONE]: { color: colors.blue[500], colorScheme: 'blue' },
};

export enum CandidatePositionNextStatus {
  CANDIDATE_ACCEPT_CONTACT_REQUEST = 'CANDIDATE_ACCEPT_CONTACT_REQUEST',
  CANDIDATE_ANSWER_PENDING_QUESTION = 'CANDIDATE_ANSWER_PENDING_QUESTION',
  RECRUITER_BOOKMARK_CANDIDATE = 'RECRUITER_BOOKMARK_CANDIDATE',
  RECRUITER_MONETIZE_CANDIDATE = 'RECRUITER_MONETIZE_CANDIDATE',
  CANDIDATE_ADD_JOB_INTEREST = 'CANDIDATE_ADD_JOB_INTEREST',
  CANDIDATE_UPDATE_EXPERIENCE = 'CANDIDATE_UPDATE_EXPERIENCE',
  CANDIDATE_UPDATE_WHERE_TO_WORK = 'CANDIDATE_UPDATE_WHERE_TO_WORK',
  CANDIDATE_WAIT_FOR_OPEN_REQUISITION = 'CANDIDATE_WAIT_FOR_OPEN_REQUISITION',
  CANDIDATE_UPDATE_AVAILABILITY = 'CANDIDATE_UPDATE_AVAILABILITY',
  CANDIDATE_REVIEW_ANSWER = 'CANDIDATE_REVIEW_ANSWER',
  CANDIDATE_UPDATE_SURPLUS_EXPERIENCE = 'CANDIDATE_UPDATE_SURPLUS_EXPERIENCE',
  RECRUITER_REVIEW_FOR_PAUSED = 'RECRUITER_REVIEW_FOR_PAUSED',
  RECRUITER_REVIEW_FOR_KNOCKOUT_FROM_QA = 'RECRUITER_REVIEW_FOR_KNOCKOUT_FROM_QA',
  RECRUITER_SEND_MODERN_HIRE_REQUEST = 'RECRUITER_SEND_MODERN_HIRE_REQUEST',
  RECRUITER_SEND_LE_REQUEST = 'RECRUITER_SEND_LE_REQUEST',
  RECRUITER_SEND_APPOINTMENT_REQUEST = 'RECRUITER_SEND_APPOINTMENT_REQUEST',
  RECRUITER_SEND_OFFER = 'RECRUITER_SEND_OFFER',
  RECRUITER_ADD_TOKENS = 'RECRUITER_ADD_TOKENS',
  CANDIDATE_COMPLETE_MODERN_HIRE = 'CANDIDATE_COMPLETE_MODERN_HIRE',
  TO_BE_DISMISSED_MH = 'TO_BE_DISMISSED_MH',
  CANDIDATE_COMPLETE_LE = 'CANDIDATE_COMPLETE_LE',
  RECRUITER_EVALUATE_LE = 'RECRUITER_EVALUATE_LE',
  TO_BE_DISMISSED_LE = 'TO_BE_DISMISSED_LE',
  CANDIDATE_UPDATE_MAX_WORKING_HOURS = 'CANDIDATE_UPDATE_MAX_WORKING_HOURS',
  CANDIDATE_ACCEPT_APPOINTMENT_REQUEST = 'CANDIDATE_ACCEPT_APPOINTMENT_REQUEST',
  RECRUITER_UPDATE_AVAILABILITY = 'RECRUITER_UPDATE_AVAILABILITY',
  ATTEND_INTERVIEW = 'ATTEND_INTERVIEW',
  RECRUITER_RESCHEDULE_INTERVIEW = 'RECRUITER_RESCHEDULE_INTERVIEW',
  RECRUITER_RESCHEDULE_INTERVIEW_CANDIDATE_NO_SHOW = 'RECRUITER_RESCHEDULE_INTERVIEW_CANDIDATE_NO_SHOW',
  RECRUITER_RESCHEDULE_INTERVIEW_RECRUITER_NO_SHOW = 'RECRUITER_RESCHEDULE_INTERVIEW_RECRUITER_NO_SHOW',
  RECRUITER_INCOMPLETE_INTERVIEW_CANDIDATE_NO_SHOW = 'RECRUITER_INCOMPLETE_INTERVIEW_CANDIDATE_NO_SHOW',
  RECRUITER_INCOMPLETE_INTERVIEW_OR_RECRUITER_NO_SHOW = 'RECRUITER_INCOMPLETE_INTERVIEW_OR_RECRUITER_NO_SHOW',
  RECRUITER_NEED_TO_RATE = 'RECRUITER_NEED_TO_RATE',
  RECRUITER_DISMISS_CANDIDATE_FOR_LOW_RATING = 'RECRUITER_DISMISS_CANDIDATE_FOR_LOW_RATING',
  CANDIDATE_WAIT_FOR_INTERVIEW_SLOT = 'CANDIDATE_WAIT_FOR_INTERVIEW_SLOT',
  CANDIDATE_WAIT_FOR_AVAILABILITY_SLOT = 'CANDIDATE_WAIT_FOR_AVAILABILITY_SLOT',
  CANDIDATE_WAIT_FOR_INTERVIEW_THRESHOLD = 'CANDIDATE_WAIT_FOR_INTERVIEW_THRESHOLD',
  CANDIDATE_ACCEPT_OFFER = 'CANDIDATE_ACCEPT_OFFER',
  RECRUITER_SEND_SCREENING = 'RECRUITER_SEND_SCREENING',
  RECRUITER_SEND_HIRE_FORM = 'RECRUITER_SEND_HIRE_FORM',
  RECRUITER_SEND_I9_REQUEST = 'RECRUITER_SEND_I9_REQUEST',
  RECRUITER_HIRE_CANDIDATE = 'RECRUITER_HIRE_CANDIDATE',
  OFFER_REJECTED_BY_RECRUITER_REVIEW_CANDIDATE = 'OFFER_REJECTED_BY_RECRUITER_REVIEW_CANDIDATE',
  TO_BE_DISMISSED_OFFER_REJECTED = 'TO_BE_DISMISSED_OFFER_REJECTED',
  REVIEW_CANDIATE_OFFER_REJECTED_SEEKER = 'REVIEW_CANDIATE_OFFER_REJECTED_SEEKER',
  RECRUITER_SEND_NEW_OFFER = 'RECRUITER_SEND_NEW_OFFER',
  TO_BE_DISMISSED_OFFER_REVOKED = 'TO_BE_DISMISSED_OFFER_REVOKED',
  REVIEW_CANDIDATE_OFFER_REVOKED = 'REVIEW_CANDIDATE_OFFER_REVOKED',
  CANDIDATE_COMPLETE_SCREENING = 'CANDIDATE_COMPLETE_SCREENING',
  RECRUITER_REVIEW_SCREENING_REPORT = 'RECRUITER_REVIEW_SCREENING_REPORT',
  CANDIDATE_FILL_HIRE_FORM = 'CANDIDATE_FILL_HIRE_FORM',
  RECRUITER_RESPOND_HELP_REQUEST = 'RECRUITER_RESPOND_HELP_REQUEST',
  RECRUITER_EVALUATE_HIRE_FORM = 'RECRUITER_EVALUATE_HIRE_FORM',
  TO_BE_DISMISSED_HIRE_FORM_REJECTED = 'TO_BE_DISMISSED_HIRE_FORM_REJECTED',
  CANDIDATE_FILL_I9 = 'CANDIDATE_FILL_I9',
  CANDIDATE_RESUBMIT_I9 = 'CANDIDATE_RESUBMIT_I9',
  RECRUITER_EVALUATE_I9 = 'RECRUITER_EVALUATE_I9',
  END_OF_WORKFLOW = 'END_OF_WORKFLOW',
}
